import { Pipe } from '@angular/core';
import { KompaktdarstellungPipe } from '../kompakt-darstellung.pipe';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { EigentumanteilMasterDetailEntryMeta, EigentumanteilVersionDetailEntryMeta } from '../../../core/gb-api';
import { TranslateService } from '@ngx-translate/core';
import { FormatConfigEntry } from '../../../core/base-api';
import { keysToTranslate } from 'i18n/keys-to-translate';

@Pipe({
  name: 'kompaktEigentumanteil'
})
export class KompaktEigentumanteilPipe extends KompaktdarstellungPipe<EigentumanteilVersionDetailEntryMeta> {
  constructor(
    protected formatConfigService: FormatConfigService,
    protected location: PlatformLocation,
    protected kompaktLocation: ComponentLocationStrategy,
    private translate: TranslateService
  ) {
    super(formatConfigService, 'EIGENTUMANTEIL', location, kompaktLocation);
    keysToTranslate<string>([
      'UNBEKANNT',
      'Eigentumsform.ALLEINEIGENTUM',
      'Eigentumsform.MITEIGENTUM',
      'Eigentumsform.GESAMTEIGENTUM',
      'HERRENLOS',
      'eigentumanteil.unbekannt',
      'eigentumanteil.anteilUnbekannt'
    ]);
  }

  transform(
    entry: EigentumanteilVersionDetailEntryMeta,
    type: FormatConfigEntry.ElementEnum = this.formatElement,
    languageChangeEvent = 'de'
  ): string {
    if (!entry) {
      return;
    }
    let value = '';
    if (type === 'EIGENTUMANTEIL_TYP00') {
      value = this.art(entry) + ' ' + this.quote(entry);
    }
    if (type === 'EIGENTUMANTEIL_TYP01') {
      value = this.art(entry);
    }
    return value;
  }

  art(entry: EigentumanteilVersionDetailEntryMeta): string {
    let key;
    if (entry.eigentumanteilArt === 'HERRENLOS') {
      key = EigentumanteilMasterDetailEntryMeta.EigentumanteilArtEnum[entry.eigentumanteilArt];
    } else if (entry.eigentumanteilArt === 'GRUNDSTUECK') {
      return '';
    } else {
      key = 'Eigentumsform.' + EigentumanteilVersionDetailEntryMeta.EigentumsformEnum[entry.eigentumsform];
    }
    return this.translate.instant(key);
  }

  quote(entry: EigentumanteilVersionDetailEntryMeta): string {
    let res = '';
    if (this.displayQuote(entry)) {
      res = entry.quote.zaehler + '/' + entry.quote.nenner;
    } else if (entry.quoteUnbekannt) {
      res = this.translate.instant('eigentumanteil.anteilUnbekannt');
    } else if (entry.quoteAlsText) {
      res = entry.quoteAlsText;
    }
    return res;
  }

  private displayQuote(entry: EigentumanteilVersionDetailEntryMeta): boolean {
    if (!entry.quote) {
      return false;
    }
    if (entry.quote.zaehler === 1 && entry.quote.nenner === 1) {
      return false;
    }
    return !(entry.quote.zaehler === 0 && entry.quote.nenner === 0);
  }
}
